import React from "react";
import CollapsedSidebarLayout from "./collapsed-sidebar-layout";

export default class CollapsedSidebar extends React.Component<any, {}> {
  render() {
    return <CollapsedSidebarLayout />;
  }
}
